import React, { Component } from "react";
import { Breadcrumb, Button } from "react-bootstrap";
import { getAirstreamUrl, getNumericalUrl, axios, recordTraffic } from "./utils";
import { getUserRole } from "./User/UserRestriction";
import { toast } from "react-toastify";
import moment from "moment";
import "../staticfiles/login.css";

export default class Login extends Component {
  state = {
    username: "",
    pwd: "",
    token: "",
    airstreamToken: "",
    showPassword: false,
  };

  redirectApp = async () => {
    try {
      let res1 = await axios.post(getNumericalUrl("auth/jwt/"), {
        username: this.state.username,
        password: this.state.pwd,
      });

      let res2 = await axios.post(getAirstreamUrl("permission/jwt/auth/"), {
        username: this.state.username,
        password: this.state.pwd,
      });

      this.setState({ token: res1.data.token });
      localStorage.setItem("RWLoginToken", res1.data.token);
      localStorage.setItem("username", this.state.username);
      localStorage.setItem("airstreamToken", res2.data.token);

      let expire = moment();
      expire.add(7, "d");
      localStorage.setItem("RWExpireDate", expire.format());

      // Fetch and cache user role
      await getUserRole(true);

      // Get user's IP address
      const resIP = await fetch("https://api.ipify.org?format=json");
      const ipData = await resIP.json();

      // Record login traffic
      recordTraffic("user_login", {
        username: this.state.username,
        ip_address: ipData.ip,
        action: "successful login",
      });

      toast.success("Login Success");
      this.props.history.push("/promotional-ensemable");
    } catch (e) {
      toast.error("Username or Password is incorrect!");
    }
  };

  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  };
  handlePwdChange = (e) => {
    this.setState({ pwd: e.target.value });
  };
  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    return (
      <div className="body-green">
        <div className="page-wrapper">
          <header id="header" className="header">
            <div className="container">
              <div className="branding">
                <h1 className="logo">
                  <a href="/">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-files"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4 2h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
                      />
                      <path d="M6 0h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1H4a2 2 0 0 1 2-2z" />
                    </svg>
                    <span class="text-highlight">RW</span>
                    <span class="text-bold">APP</span>
                  </a>
                </h1>
              </div>

              <Breadcrumb className="breadcrumb">
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Quick Start</Breadcrumb.Item>
              </Breadcrumb>

              <div className="top-search-box">
                <form
                  className="form-inline search-form justify-content-center"
                  action=""
                  method="get"
                >
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Search..."
                      name="search"
                      className="form-control search-input"
                    />
                    <button
                      type="submit"
                      className="btn search-btn"
                      value="Search"
                    >
                      <svg
                        className="svg-inline--fa fa-search fa-w-16"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="search"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        data-fa-i2svg=""
                        style={{ width: "14px", height: "14px" }}
                      >
                        <path
                          fill="currentColor"
                          d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </header>

          <section class="cards-section text-center">
            <div class="container">
              <h2 class="title">User Authentication</h2>
              <div class="intro">
                <p>
                  The following content is proprietary and confidential property
                  of Random Walk Financial. These contents are intended solely
                  for analysis by Random Walk clients. By logging in you are
                  indicating you are a client of random walk financial. We use
                  tracking tools to monitor unauthorized access which is
                  prohibited.
                </p>
              </div>

              <div className="container">
                <div id="cards-wrapper" className="cards-wrapper row">
                  <div className="offset-md-2 col-sm-8">
                    <div className="card item item-pink item-1">
                      <div className="item-inner card-subtitle">
                        {/* <p>
													Your account doesn't have access to this page. To
													proceed, please login with an account that has access.
												</p> */}

                        <form method="post" action="/accounts/login/">
                          <input
                            type="hidden"
                            name="csrfmiddlewaretoken"
                            value="HBw7bk17Fu5zTpMpa8rPzE4YVzOZlXcEBEiUxdR8GBH0xVL0XaYKhi6F2W0lbhxB"
                          />
                          <div className="row form-group">
                            <label
                              className="col-sm-3 col-form-label"
                              for="id_username"
                            >
                              Username:
                            </label>
                            <div className="col-sm-9">
                              <input
                                className="form-control"
                                type="text"
                                name="username"
                                onChange={(e) => this.handleUsernameChange(e)}
                                autoFocus=""
                                autoCapitalize="none"
                                autocomplete="username"
                                maxLength="150"
                                required=""
                                id="id_username"
                              />
                            </div>
                          </div>
                          <div className="row form-group">
                            <label
                              className="col-sm-3 col-form-label"
                              for="id_password"
                            >
                              Password:
                            </label>
                            <div className="col-sm-9" style={{ position: 'relative' }}>
                              <input
                                className="form-control"
                                type={this.state.showPassword ? "text" : "password"}
                                name="password"
                                onChange={(e) => this.handlePwdChange(e)}
                                autocomplete="current-password"
                                required=""
                                id="id_password"
                                style={{ paddingRight: '40px' }}
                              />
                              <button
                                type="button"
                                onClick={this.togglePasswordVisibility}
                                style={{
                                  position: 'absolute',
                                  right: '25px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  padding: '5px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  zIndex: 10,
                                  height: '30px',
                                  width: '30px'
                                }}
                                aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  viewBox="0 0 16 16"
                                  style={{ opacity: 0.6 }}
                                >
                                  {this.state.showPassword ? (
                                    // Eye slash icon (hide password)
                                    <>
                                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                    </>
                                  ) : (
                                    // Eye icon (show password)
                                    <>
                                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                    </>
                                  )}
                                </svg>
                              </button>
                            </div>
                          </div>

                          <Button
                            class="btn btn-primary mt-3"
                            onClick={this.redirectApp}
                          >
                            Login
                          </Button>
                          <input
                            type="hidden"
                            name="next"
                            value="/promotional-ensemable"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <section class="cards-section text-center">
                    <div class="container">
                        <h2 class="title">User Authentication</h2>
                        <div class="intro">
                            <p>The following content is proprietary and confidential property of Random Walk Financial. These contents are intended solely for analysis by Random Walk clients. By logging in you are indicating you are a client of random walk financial. We use tracking tools to monitor unauthorized access which is prohibited.</p>
                        </div>
                        <div id="cards-wrapper" class="cards-wrapper row">
                            <div class="item item-pink item-1 offset-2 col-8">
                                <div class="item-inner">
                                    <p>Your account doesn't have access to this page. To proceed,
                                        please login with an account that has access.
                                    </p>
                                    <form method="post" action="/accounts/login/">
                                        <input type="hidden" name="csrfmiddlewaretoken" value="HBw7bk17Fu5zTpMpa8rPzE4YVzOZlXcEBEiUxdR8GBH0xVL0XaYKhi6F2W0lbhxB"/>
                                        <div class="form-group">
                                            <label><label for="id_username">Username:</label></label>
                                            <input type="text" name="username" onChange={(e)=>this.handleUsernameChange(e)} autoFocus="" autoCapitalize="none" autocomplete="username" maxLength="150" required="" id="id_username"/>
                                        </div>
                                        <div class="form-group">
                                            <label><label for="id_password">Password:</label></label>
                                            <input type="password" name="password" onChange={(e)=>this.handlePwdChange(e)} autocomplete="current-password" required="" id="id_password"/>
                                        </div>
                                        <Button class="btn btn-primary mt-3" onClick={this.redirectApp}>Login</Button>
                                        <input type="hidden" name="next" value="/chart/deep-discount/"/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
            </section> */}

        <footer id="footer" className="footer">
          <div className="container">
            <div className="row">
              <div className="text-center">
                <small className="copyright">
                  ©2025 <a href="http://ranwalk.com/">RANDOM WALK FINANCIAL</a>.
                  ALL RIGHTS RESERVED.
                </small>
              </div>
              <div className="pull-right">
                <small className="copyright">
                  Support by{" "}
                  <a
                    href="monte.carlo@goldbeyond.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Monte Carlo Consulting LLC
                  </a>
                  .
                </small>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
